module.exports = __webpack_public_path__ + "static/media/noAnnouncement.4bf7edd1.svg";